// modalUtils.js
import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { Modal, Icon } from 'pepsico-ds'

// The actual modal component (internal to this file)
const NotificationModal = ({ 
  title, 
  text, 
  icon = 'warning', 
  button = 'Go Back',
  onClose
}) => {
  if(title==="Data Unavailable") {
    return (
      <Modal                   
              className="ph-notification-modal"
              closeOnOutsideClick={true}
              hideCloseButton
              onCloseModal={function oFe(){onClose()}}
              primaryButtonProps={{
              onClick: onClose,
              size: 'medium',
              text: 'Go Back',
              variant: 'primary'
              }}
              showModal={true}
              showLink={false}
              showSecondaryButton={false}
              showTertiaryButton={false}
              showAuxiliaryButton={false}
              type="S"
          >
              <div style={{}}>
                <div className='no-data-container' style={{border: "1px solid #D7E5F8", padding:"16px"}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                        <path d="M32.0002 14H38.0002L30.0002 6L22.0002 14H28.0002V22.34L32.0002 26.34V14Z" fill="#3A3A3A" />
                        <path d="M5.62027 5.61914L2.78027 8.43914L16.0003 21.6591V34.0191L10.0003 34.0391L18.0003 41.9991L26.0003 33.9991L20.0003 34.0191V25.6591L39.5603 45.2191L42.3803 42.3791L5.62027 5.61914Z" fill="#3A3A3A" />
                    </svg>
                    <div className='no-data-title'>No data available</div>
                    <div className='no-data-desc'>{text}</div>
                </div>
              </div>
          </Modal>
    );
  } else {
    return (
      <Modal                   
              className="ph-notification-modal"
              closeOnOutsideClick={true}
              hideCloseButton
              onCloseModal={function oFe(){onClose()}}
              primaryButtonProps={{
              onClick: onClose,
              size: 'medium',
              text: 'Go Back',
              variant: 'primary'
              }}
              // secondaryButtonProps={{
              // onClick: onClose,
              // size: 'medium',
              // text: 'Exit',
              // variant: 'tertiary'
              // }}
              showModal={true}
              showLink={false}
              showSecondaryButton={false}
              showTertiaryButton={false}
              showAuxiliaryButton={false}
              type="S"
          >
              <div style={{}}>
                  
                  <div style={{fontSize: '22px', fontWeight: 'bold', marginBottom: '10px', color: '#3A3A3A', display: "flex"}}>
                      <Icon alt="" icon="error_outline" size="large" style={{marginTop:"4px"}} />&nbsp;
                      <span>{title}</span>
                  </div>
                  <div>{text}</div>
              </div>
          </Modal>
    );

  }
  
};

// The main function that you'll use instead of swal()
// const showNotificationModal = ({ title, text, icon = 'warning', button = 'Go Back' }) => {
//   // Create a div to mount our modal
//   const modalRoot = document.createElement('div');
//   document.body.appendChild(modalRoot);
  
//   // Return a promise so you can use .then() like with swal
//   return new Promise(resolve => {
//     const closeModal = () => {
//       ReactDOM.unmountComponentAtNode(modalRoot);
//       document.body.removeChild(modalRoot);
//       resolve();
//     };
    
//     ReactDOM.render(
//       <NotificationModal 
//         title={title}
//         text={text}
//         icon={icon}
//         button={button}
//         onClose={closeModal}
//       />,
//       modalRoot
//     );
//   });
// };

const showNotificationModal = ({ title, text, icon = 'warning', button = 'Go Back' }) => {
  // Create a div to mount our modal
  const modalRoot = document.createElement('div');
  document.body.appendChild(modalRoot);
  
  // Create a root using the new API
  const root = createRoot(modalRoot);
  
  // Return a promise so you can use .then() like with swal
  return new Promise(resolve => {
    const closeModal = () => {
      // Unmount using the new API
      root.unmount();
      document.body.removeChild(modalRoot);
      resolve();
    };
    
    // Render using the new API
    root.render(
      <NotificationModal 
        title={title}
        text={text}
        icon={icon}
        button={button}
        onClose={closeModal}
      />
    );
  });
};

export default showNotificationModal;